<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="FMH">CONTENTS</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample">Dedication</span></p>
<p class="toc1"><a href="#/xhtml/epigraph#epig">Epigraphs</a></p>
<p class="toc" id="c_ch1"><a href="#/xhtml/chapter1#ch1">1. Apollo</a></p>
<p class="toc" id="c_ch2"><a href="#/xhtml/chapter2#ch2">2. Simmea</a></p>
<p class="toc" id="c_ch3"><a href="#/xhtml/chapter3#ch3">3. Maia</a></p>
<p class="toc" id="c_ch4"><a href="#/xhtml/chapter4#ch4">4. Simmea</a></p>
<p class="toc" id="c_ch5"><a href="#/xhtml/chapter5#ch5">5. Maia</a></p>
<p class="toc" id="c_ch6"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">6. Simmea</span></p>
<p class="toc" id="c_ch7"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">7. Apollo</span></p>
<p class="toc" id="c_ch8"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">8. Simmea</span></p>
<p class="toc" id="c_ch9"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">9. Maia</span></p>
<p class="toc" id="c_ch10"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">10. Simmea</span></p>
<p class="toc" id="c_ch11"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">11. Maia</span></p>
<p class="toc" id="c_ch12"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">12. Simmea</span></p>
<p class="toc" id="c_ch13"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">13. Apollo</span></p>
<p class="toc" id="c_ch14"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">14. Simmea</span></p>
<p class="toc" id="c_ch15"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">15. Maia</span></p>
<p class="toc" id="c_ch16"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">16. Simmea</span></p>
<p class="toc" id="c_ch17"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">17. Maia</span></p>
<p class="toc" id="c_ch18"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">18. Simmea</span></p>
<p class="toc" id="c_ch19"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">19. Apollo</span></p>
<p class="toc" id="c_ch20"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">20. Simmea</span></p>
<p class="toc" id="c_ch21"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">21. Maia</span></p>
<p class="toc" id="c_ch22"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">22. Simmea</span></p>
<p class="toc" id="c_ch23"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">23. Maia</span></p>
<p class="toc" id="c_ch24"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">24. Simmea</span></p>
<p class="toc" id="c_ch25"><span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample">25. Apollo</span></p>
<p class="toc" id="c_ch26"><span href="#/xhtml/chapter26#ch26" title="Link target outside of Sample">26. Simmea</span></p>
<p class="toc" id="c_ch27"><span href="#/xhtml/chapter27#ch27" title="Link target outside of Sample">27. Maia</span></p>
<p class="toc" id="c_ch28"><span href="#/xhtml/chapter28#ch28" title="Link target outside of Sample">28. Simmea</span></p>
<p class="toc" id="c_ch29"><span href="#/xhtml/chapter29#ch29" title="Link target outside of Sample">29. Maia</span></p>
<p class="toc" id="c_ch30"><span href="#/xhtml/chapter30#ch30" title="Link target outside of Sample">30. Simmea</span></p>
<p class="toc" id="c_ch31"><span href="#/xhtml/chapter31#ch31" title="Link target outside of Sample">31. Apollo</span></p>
<p class="toc" id="c_ch32"><span href="#/xhtml/chapter32#ch32" title="Link target outside of Sample">32. Simmea</span></p>
<p class="toc" id="c_ch33"><span href="#/xhtml/chapter33#ch33" title="Link target outside of Sample">33. Maia</span></p>
<p class="toc" id="c_ch34"><span href="#/xhtml/chapter34#ch34" title="Link target outside of Sample">34. Simmea</span></p>
<p class="toc" id="c_ch35"><span href="#/xhtml/chapter35#ch35" title="Link target outside of Sample">35. Maia</span></p>
<p class="toc" id="c_ch36"><span href="#/xhtml/chapter36#ch36" title="Link target outside of Sample">36. Simmea</span></p>
<p class="toc1" id="c_ch37"><span href="#/xhtml/chapter37#ch37" title="Link target outside of Sample">37. Apollo</span></p>
<p class="toc" id="c_Tha"><span href="#/xhtml/bm#Tha" title="Link target outside of Sample">Thanks and Notes</span></p>
<p class="toc"><span href="#/xhtml/teaser#tea" title="Link target outside of Sample">Excerpt: <span class="ePub-I">Or What You Will</span></span></p>
<p class="toc" id="adcard_R"><span href="#/xhtml/adcard#adcard" title="Link target outside of Sample">Tor Books by Jo Walton</span></p>
<p class="toc" id="c_ata"><span href="#/xhtml/abouttheauthor#ata" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?053c0c54